import { CommonModule } from "@angular/common";
import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from "@angular/core";
import { NavigationEnd, Router, RouterModule } from "@angular/router";
import { filter } from "rxjs";
import { Title } from "@angular/platform-browser";
import { SessionService } from "../../../../Utils/_services/session/session.service";

interface SidebarItem {
  label: string;
  icon: string;
  route: string;
}

@Component({
  selector: "app-sidebar",
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: "./sidebar.component.html",
  styleUrl: "./sidebar.component.css",
})
export class SidebarComponent implements OnInit {
  constructor(
    private titleService: Title,
    private router: Router,
    private sessionService: SessionService
  ) {}

  @Input() collapsed: boolean = false;
  @HostBinding('class.collapsed') get isCollapsed() { return this.collapsed; }
  @Output() toggleSidebar = new EventEmitter<void>();
  currentRoute = "";
  callCount = 0;
  logoLoadError = false;

  menuItems: SidebarItem[] = [
    { label: "Dashboard", icon: "pi pi-th-large", route: "/admin/dashboard" },
    { label: "Users", icon: "pi pi-users", route: "/admin/users" },
    { label: "Waitlisted User", icon: "pi pi-list", route: "/admin/waitlisted-user" },
    { label: "Verification Requests", icon: "pi pi-plus-circle", route: "/admin/verification-requests" },
    { label: "Violation Reports", icon: "pi pi-exclamation-circle", route: "/admin/voilation-report" },
    { label: "Payments", icon: "pi pi-wallet", route: "/admin/payment-transactions" },
    { label: "Custom Logger", icon: "fa-solid fa-box", route: "/admin/logs" },
    { label: "Partners", icon: "fa-regular fa-handshake", route: "/admin/partners" },
    { label: "Notification Management", icon: "pi pi-bell", route: "/admin/notification-management" },
    { label: "Brand Images", icon: "pi pi-images", route: "/admin/brand-images" },
    { label: "Settings", icon: "pi pi-cog", route: "/admin/settings" },
  ];

  ngOnInit() {
    // Track route changes
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentRoute = event.url;
      });

    // Set initial route
    this.currentRoute = this.router.url;
  }

  isActive(route: string): boolean {
    return this.currentRoute === route || this.currentRoute.startsWith(route);
  }

  onToggleSidebar() {
    this.toggleSidebar.emit();
  }

  setTitle(label: string) {
    this.titleService.setTitle(label);
  }
}
